import * as z from "zod";

export const revokeApiToken = {
  name: "revokeApiToken" as const,
  input: z.object({ id: z.bigint() }),
  output: z.object({ success: z.boolean() }),
};
